<template>
  <div class="common-ad">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>首页</BreadcrumbItem>
          <BreadcrumbItem>展会设置</BreadcrumbItem>
          <BreadcrumbItem>下载管理</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">下载管理</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="show=true;">
          <span>添加文件</span>
        </div>
      </div>
    </div>
    <div style="padding:24px 0 0 24px;">
      <RadioGroup v-model="downType" type="button" @on-change="typeChange">
        <Radio label="中文文件"></Radio>
        <Radio label="英文文件"></Radio>
      </RadioGroup>
    </div>
    <div class="common-down">
      <div class="cd-box" v-if="downList && downList.length > 0">
        <Row class="cd-item" v-for="(item, index) in downList" :key="'downList-' + index">
          <Col span="20" class="cd-item-l">
            <img :src="fileName(item.path)" /> 
            <span>{{item.name}}</span>
          </Col>
          <Col span="4" class="cd-item-r">
            <Poptip
              width="160"
              confirm
              placement="top-start"
              title="确认删除此文件吗 ?"
              @on-ok="delItem(item)"
            >
              <a href="javascript:;">删除</a>
            </Poptip>
          </Col>
        </Row>
      </div>
      <div v-else style="line-height:500px;text-align:center;">暂无数据</div>
    </div>
    <!-- <div class="my-page" v-if="totalCount > pageSize" style="text-align:center;">
      <Page
        show-total
        show-elevator
        :page-size="pageSize"
        :current="pageIndex"
        :total="totalCount"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      />
    </div> -->

    <commonAdDown :show="show" @finish="init()" :downType="downType" @close="show=false;" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import commonAdDown from "../components/common-ad-down.vue";
import Docx from "@assets/img/type/docx.png";
import Png from "@assets/img/type/png.png";
import Jpg from "@assets/img/type/jpg.png";
import Pdf from "@assets/img/type/pdf.png";
import Ppt from "@assets/img/type/ppt.png";
import Txt from "@assets/img/type/txt.png";
import Unkown from "@assets/img/type/unknow.png";
import Xls from "@assets/img/type/xls.png";
import Zip from "@assets/img/type/zip.png";

export default {
  name: "host-common-down",
  data() {
    return {
      imgSrc: Png,

      pageIndex: 1,
      pageSize: 12,
      totalCount: 0,
      showTabs: "1",
      show: false,
      downList: [],
      downType: "中文文件",
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      exhibition: "hostSetModule/getHostExhibition"
    }),
    imgArr() {
      return {
        doc: Docx,
        docx: Docx,
        png: Png,
        jpg: Jpg,
        jpeg: Jpg,
        pdf: Pdf,
        ppt: Ppt,
        pptx: Ppt,
        txt: Txt,
        unkown: Unkown,
        xls: Xls,
        xlsx: Xls,
        zip: Zip
      };
    }
  },
  methods: {
    ...mapActions({
      getDownByExhibition: "hostDownModule/getDownByExhibition",
      addDown: "hostDownModule/addDown",
      delDown: "hostDownModule/delDown"
    }),
    async init() {
      let result = await this.getDownByExhibition(this.exhibition.id);
      if (result.length > 0) {
        if (this.downType === "中文文件") {
          let arr = [];
          result.map(c => {
            if (c.typeId === 0) {
              arr.push(c);
            }
          })
          this.downList = arr;
        }
        if (this.downType === "英文文件") {
          let arr = [];
          result.map(c => {
            if (c.typeId === 1) {
              arr.push(c);
            }
          })
          this.downList = arr;
        }
      } else {
        this.downList = [];
      }
      // this.totalCount = result.length;
    },
    typeChange(e) {
      this.init();
    },
    fileName(file) {
      if (!file) return;
      //截取文件后缀
      let file_name = file.substring(file.lastIndexOf(".") + 1);
      let name = this.imgArr[file_name];
      return name ? name : this.imgArr["unkown"];
    },
    async delItem(item) {
      let result = await this.delDown(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    }
  },
  components: {
    commonAdDown
  }
};
</script>

<style lang="scss" scoped>
.common-down {
  margin: 24px;
  background: #fff;
  min-height: 500px;
  min-width: 600px;
  .cd {
    &-box {
      padding: 0 30px;
    }
    &-item {
      height: 90px;
      border-bottom: 1px solid #e9e9e9;
      &-l {
        display: flex;
        height: 90px;
        align-items: center;
        img {
          width: 55px;
          height: 55px;
          margin-right: 20px;
        }
        span {
          font-size: 16px;
          color: #333;
        }
      }
      &-r {
        display: flex;
        height: 90px;
        align-items: center;
      }
    }
  }
}
</style>